export default __webpack_public_path__ + "static/SmilyFace-da5bce68b39a2ff1df3707250150a208.png";